import { ApiPosition } from "../../models/api";
import { Position } from "../../models/client";

export function toPosition(apiPosition: ApiPosition): Position {
  return {
    x: apiPosition.X,
    y: apiPosition.Y,
  };
}
